import RegisterForm from "../components/users/registerForm/RegisterForm";

const Register = () => {
  return (
    <div className="login-page">
      <h3>Register</h3>
      <RegisterForm />
    </div>
  );
};
export default Register;
